export default function getDivHeight(id) {
    if (!id) return;
    const element = document.getElementById(id);
    if (element) {
        return element.offsetHeight;
    }
    return 0;
}
